import { render, staticRenderFns } from "./AdminBookingRequests.vue?vue&type=template&id=42594f0d"
import script from "./AdminBookingRequests.vue?vue&type=script&lang=js"
export * from "./AdminBookingRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports